import { Box, ButtonBase, ClickAwayListener, makeStyles, Popper } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  remarkColorPopup: {
    zIndex: '9999',
  },
  item: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    padding: '6px 16px',
    justifyContent: 'flex-start',
    textAlign: 'left',
    '&:hover': {
      backgroundColor: '#f1f6ff',
      color: '#538fff',
    },
  },
}));
const AddRemarks = ({ anchorEl, handleClose, handleClick, remarkList }) => {
  const classes = useStyles();

  return (
    Boolean(anchorEl) && (
      <ClickAwayListener onClickAway={handleClose}>
        <Popper
          className={classes.remarkColorPopup}
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          placement="bottom"
          transition
        >
          <Box
            display="flex"
            flexDirection="column"
            minWidth="13rem"
            maxWidth="25rem"
            border="solid 1px #e4e7eb"
            bgcolor="#fff"
            boxShadow="0 1px 6px 0 rgba(0, 0, 0, 0.12)"
            borderRadius="10px"
            padding="0.5rem 0"
            maxHeight="22rem"
            overflow="auto"
          >
            {remarkList?.length > 0 ? (
              remarkList?.map((item) => (
                <ButtonBase className={classes.item} key={item.remarkId} onClick={() => handleClick(item?.remark)}>
                  {item.remark}
                </ButtonBase>
              ))
            ) : (
              <ButtonBase className={classes.item} disabled>
                No Option
              </ButtonBase>
            )}
          </Box>
        </Popper>
      </ClickAwayListener>
    )
  );
};

export default AddRemarks;
